<template>
 <!--  <transition name="toggle" mode="out-in" :duration="200">
    <div v-if="!loaded" class="filters-car-brand--empty" key="empty">
      <div v-for="(type, i) in mapOldBodyTypes" :key="i" class="filter-car-body-type" style="flex-direction: column; align-items: center;">
        <div class="car-filter-checkmark">
          <span class="empty-block--image shine-short"></span>
        </div>
        <div class="empty-block--title shine-short" style="top: 6px"></div>
      </div>
    </div>-->
    <div class="filters-car-brand--full" key="full">
      <div v-for="(body, i) in mapBodyTypes" :key="i" class="filter-car-body-type" :class="{'active': body.active}">
        <div @click="selectedBody(body.id)">
          <div class="filter-car-body-type__image-wrapper" >
            <img class="filter-car-body-type__image" :src="body.image" alt/>
          </div>
          <div class="filter-car-body-type__name">{{ body.name }}</div>
        </div>
      </div>
    </div>
  <!--</transition> -->
</template>

<script>
import {mapState} from 'vuex'
import dealers from "@/mixins/dealers";

const pathImages = '/img/car-body-types/'

export default {
  props: {
    filters: {
      type: Object,
      default: () => {}
    },
    isOldCars: Boolean
  },
  mixins: [dealers],
  created(){
    console.log('this.filters',this.filters)
  },
  data: () => ({
    carBodyTypes: [
      {
        id: 0,
        image: `${pathImages}Folksbill.png`,
        name: 'Fólksbíll'
      }, {
        id: 2317,
        image: `${pathImages}Smabil.png`,
        name: 'Smábíl'
      }, {
        id: 28,
        image: `${pathImages}Sportjeppi.png`,
        name: 'Sportjeppi'
      }, {
        id: 1,
        image: `${pathImages}Skutbill.png`,
        name: 'Skutbíll'
      }, {
        id: 2316,
        image: `${pathImages}Saeta.png`,
        name: ' 7 Sæta'
      }, {
        id: 9999,
        image: `${pathImages}Rafbill.png`,
        name: 'Rafbíll'
      }, 
    ]
  }),
  methods: {
    selectedBody(id) {
      if (id == 9999) {
        const i = this.filters.fuel_type.indexOf('2')
        if (i >= 0) {
          this.filters.fuel_type.splice(i, 1)
        }
        else {
          this.filters.fuel_type.push('2')
        }
      }
      else {
        const filterBodyTypes = this.filters[this.categoryField]
        const i = filterBodyTypes.map(item=>parseInt(item)).indexOf(id)
        if (i >= 0 ) {
          filterBodyTypes.splice(i, 1)
        }
        else {
          filterBodyTypes.push(id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      loadedNewCars: state => state.dataCarsLoadedFlag
    }),
    loaded() {
      return this.isOldCars
        ? true
        : this.loadedNewCars
    },
     mapOldBodyTypes() {
      return this.carBodyTypes.map(body => ({
        ...body,
        active: this.filters && this.filters[this.categoryField] && this.filters[this.categoryField].some(cat => cat == body.id) || (body.id == 9999 && this.filters && this.filters.fuel_type && this.filters.fuel_type.includes('2'))
      }))
     },
    mapBodyTypes() {
      return this.carBodyTypes.map(body => ({
        ...body,
        active: this.filters && this.filters[this.categoryField]
            && this.filters[this.categoryField].some(cat => cat == body.id)
            || (body.id == 9999
                && (this.filters.fuel_type && this.filters.fuel_type.includes('2')))
      }))
    },
    categoryField() {
      return this.isOldCars 
        ? 'flokkar' //''
        : 'cat'
    }
  }
}
</script>

<style lang="less" scoped>
.filter-car-body-type {
    padding: 6px;
    cursor: pointer;
    width: calc(100%/3);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;

    &__image-wrapper {
      border: 2px solid #eaeaea;
      width: 96px;
      height: 78px
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &__name {
      color: #575962;
      font-size: 13px;
      text-align: center;
      padding: 5px 0;
      &.active {
        color: #3f51ae;
      }
    }

    &:hover {
      .filter-car-body-type {
        &__image-wrapper {
          background: #eaeaea;
        }

        &__name {
          color: #3f51ae;
        }
      }
    }

    &.active {
      .filter-car-body-type {
        &__image-wrapper {
          border: 2px solid #3f51ae;
        }

        &__name {
          color: #3f51ae;
        }
      }
    }
}
.empty-block--image {
  height: 90%;
  width: 90%;
  margin: auto;
}
.car-filter-checkmark {
  width: 85%;
}
</style>